import { Injectable } from '@angular/core';
import { MessageType } from '../../src/typings/MessageType';
import { DialogConfirmOptions } from '../../src/typings/models';
import { IDeviceAutoCommission } from '../alerts/typings/IDeviceAutoCommission';
import { DialogService } from '../dialog-service/dialog.service';

@Injectable({
    providedIn: 'root'
})
export class JobNumberPopupService {
    public static $name = 'jobNumberPopupService';

    constructor(
        private dialogService: DialogService
    ) {
    }

    public showJobNumberPopupDialog(data: IDeviceAutoCommission) {
        const options = this.getDialogOptions(data);
        return this.dialogService.showConfirmDialog(options);
    }

    private getDialogOptions(data: IDeviceAutoCommission): DialogConfirmOptions {
        return {
            confirmBtnText: 'Yes',
            message: `Would you like to open Job ${data.jobNumber}?`,
            messageType: MessageType.Info,
            title: 'Device AutoCommissioned!'
        };
    }
}
